import { Link } from 'react-router';

import { useLanguage } from '../../contexts/language';

import { Brand } from '../brand';
import { FeatureCard } from '../feature-card';
import { HeroPicture } from '../hero-picture';
import { SharingBox } from '../sharing-box';
import { StartSteps } from '../start-steps';

import styles from './style.module.css';

// The page a signed-out visitor sees at the root (#110), as the blueprint's
// Landing page draws it: what psy is for, for patients and for clinicians,
// what is shared and how it starts. Every action is the same door in, the
// email-code sign-in. It is static: it reads nothing but the session the app
// already asked for, and its examples are fictional.
//
// The privacy notice and terms of use the blueprint shows in the footer are
// left out until their texts exist.
const patientIcons = [ 'record', 'check', 'calendar', 'pen' ];
const clinicianIcons = [ 'patients', 'check', 'chart', 'download' ];

export function Landing() {
  const { text } = useLanguage();
  const copy = text.landing;

  return (
    <>
      <header className={ styles.bar }>
        <div className={ styles.barInner }>
          <Brand size={ 40 } nameOnPhone={ true }/>

          <Link className={ styles.signIn } to='/signin'>{ copy.signIn }</Link>
        </div>
      </header>

      <main className={ styles.main }>
        <section className={ styles.hero } aria-labelledby='landing-title'>
          <div className={ styles.heroText }>
            <span className={ styles.kicker }>{ copy.kicker }</span>

            <h1 id='landing-title' className={ styles.title }>{ copy.title }</h1>

            <p className={ styles.intro }>{ copy.intro }</p>

            <div className={ styles.start }>
              <Link className={ styles.startLink } to='/signin'>{ copy.start }</Link>

              <span className={ styles.invited }>{ copy.invited }</span>
            </div>
          </div>

          <HeroPicture/>
        </section>

        <section className={ styles.section } aria-labelledby='for-patients'>
          <h2 id='for-patients' className={ styles.heading }>{ copy.forYou }</h2>

          <div className={ styles.cards }>
            { copy.patient.map(function({ title, text: sentence }, index) {
              return <FeatureCard key={ title } icon={ patientIcons[ index ] } title={ title }>{ sentence }</FeatureCard>;
            }) }
          </div>
        </section>

        <section className={ styles.section } aria-labelledby='for-clinicians'>
          <h2 id='for-clinicians' className={ styles.heading }>{ copy.forClinicians }</h2>

          <div className={ styles.cards }>
            { copy.clinician.map(function({ title, text: sentence }, index) {
              return <FeatureCard key={ title } icon={ clinicianIcons[ index ] } title={ title }>{ sentence }</FeatureCard>;
            }) }
          </div>
        </section>

        <SharingBox title={ copy.sharedTitle } points={ copy.shared }/>

        <section className={ styles.section } aria-labelledby='how-it-starts'>
          <h2 id='how-it-starts' className={ styles.heading }>{ copy.howItStarts }</h2>

          <StartSteps steps={ copy.steps }/>
        </section>
      </main>

      <footer className={ styles.footer }>
        <div className={ styles.footerInner }>
          <Brand size={ 32 } nameOnPhone={ true }/>

          <Link className={ styles.footerLink } to='/signin'>{ copy.signIn }</Link>

          <span className={ styles.languages }>{ copy.languages }</span>
        </div>
      </footer>
    </>
  );
}
